import React from "react";
import SwitchRow from "./SwitchRow"; // Ensure this component exists

const EditScheduling = ({ data, setData }) => {
  // Merge props data with defaults to ensure all fields exist
  const formData = { ...(data || {}) };

  // Handle regular input changes
  const handleChange = (e) => {
    const { name, value, type } = e.target;
    setData((prev) => ({
      ...prev,
      [name]: type === "number" ? Number(value) : value,
    }));
  };

  // Handle switch toggles
  const handleSwitchChange = (field, value) => {
    setData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  return (
    <div className="space-y-8">
      {/* Basics */}
      <div className="bg-white px-6">
        <h2 className="text-2xl font-semibold text-gray-900 mb-6">Basics</h2>
        <div className="grid grid-cols-3 gap-6 mb-8">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              First day of week
            </label>
            <p className="text-xs text-gray-500 mb-2">
              This determines the start day of the schedule and also sets the
              default week period for calculating weekly overtime.
            </p>
          </div>
          <div>
            <select
              name="firstDayOfWeek"
              value={formData.firstDayOfWeek}
              onChange={handleChange}
              className="w-full rounded border-gray-300 bg-slate-100 p-2"
            >
              <option value="Mon">Mon</option>
              <option value="Tue">Tue</option>
              <option value="Wed">Wed</option>
              <option value="Thr">Thr</option>
              <option value="Fri">Fri</option>
              <option value="Sat">Sat</option>
              <option value="Sun">Sun</option>
            </select>
          </div>
        </div>

        <div className="grid grid-cols-3 gap-6 mb-8">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Default shift duration (hours)
            </label>
            <p className="text-xs text-gray-500 mb-2">
              Default shift length when creating shifts.
            </p>
          </div>
          <div>
            <input
              type="number"
              name="defaultShiftDuration"
              value={formData.defaultShiftDuration}
              onChange={handleChange}
              className="w-full rounded border-gray-300 bg-slate-100 p-2"
            />
          </div>
        </div>

        <div className="grid grid-cols-3 gap-6 mb-8">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Default break duration (minutes)
            </label>
            <p className="text-xs text-gray-500 mb-2">
              Default break length when creating shifts.
            </p>
          </div>
          <div>
            <input
              type="number"
              name="defaultBreakDuration"
              value={formData.defaultBreakDuration}
              onChange={handleChange}
              className="w-full rounded border-gray-300 bg-slate-100 p-2"
            />
          </div>
        </div>
      </div>

      {/* Creating and publishing shifts */}
      <div className="bg-white px-6 mt-12">
        <h2 className="text-2xl font-semibold text-gray-900 mb-8">
          Creating and publishing shifts
        </h2>
        <div className="space-y-6">
          <div className="grid grid-cols-3 gap-6 mb-8">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Prevent changes to shift
              </label>
              <p className="text-xs text-gray-500 mb-2">
                Shifts will lock after a set time period.
              </p>
            </div>
            <div>
              <select
                name="preventChangesToShifts"
                // value={formData.firstDayOfWeek}
                onChange={handleChange}
                className="w-full rounded border-gray-300 bg-slate-100 p-2"
              >
                <option value="never">Never</option>
                <option value="after_7_days">After 7 days</option>
                <option value="after_3_days">After 3 days</option>
                <option value="after_1_day">After 1 day</option>
              </select>
            </div>
          </div>
          {/* <div className="grid grid-cols-3 gap-6 mb-8">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Shift notifications recipient
              </label>
              <p className="text-xs text-gray-500 mb-2">
                Shift notifications will be sent for late team members and shift
                swap approvals.
              </p>
            </div>
            <div>
              <select
                name="shiftNotificationsRecipient"
                // value={formData.firstDayOfWeek}
                onChange={handleChange}
                className="w-full rounded border-gray-300 bg-slate-100 p-2"
              >
                <option value="best_fit">Best Fit</option>
                <option value="schedule_manager_location">
                  Scheduling Managers of Location
                </option>
                <option value="schedule_manager_location_working">
                  Scheduling Managers of Location & Working
                </option>
                <option value="schedule_creator">Schedule Creator</option>
              </select>
            </div>
          </div>
          <div className="grid grid-cols-3 gap-6 mb-8">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Send notification to team member when shifts are removed
              </label>
              <p className="text-xs text-gray-500 mb-2">
                Notify team members when they are removed from a published
                shift.
              </p>
            </div>
            <div>
              <select
                name="sendNotificationOnShiftRemoval"
                // value={formData.firstDayOfWeek}
                onChange={handleChange}
                className="w-full rounded border-gray-300 bg-slate-100 p-2"
              >
                <option value="no_notification_for_shift_removal">
                  No notifications for shift removal
                </option>
                <option value="email_and_smartphone_notification">
                  Email and smartphone push notifications
                </option>
              </select>
            </div>
          </div> */}

          <SwitchRow
            label="Allow team members to claim or request open shifts if unavailable"
            description="This enables team members to claim open shifts or request open shifts with approval even if they are unavailable or partially available. This extends to team member initiated swaps and offers."
            checked={formData.allowToClaimOrRequestOpenShifts}
            onChange={(val) =>
              handleSwitchChange("allowToClaimOrRequestOpenShifts", val)
            }
          />

          <div className="grid grid-cols-3 gap-6 mb-8">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Turn unconfirmed published shifts to open shifts
              </label>
              <p className="text-xs text-gray-500 mb-2">
                After this timeframe, unconfirmed published shifts will become
                open shifts.
              </p>
            </div>
            <div>
              <select
                name="turnUnconfirmedPublishedShiftsToOpenShifts"
                // value={formData.firstDayOfWeek}
                onChange={handleChange}
                className="w-full rounded border-gray-300 bg-slate-100 p-2"
              >
                <option value="not_required">Not Required</option>
                <option value="12hours_before_start_time">
                  12 Hours Before Start Time
                </option>
                <option value="24hours_before_start_time">
                  24 Hours Before Start Time
                </option>
                <option value="3days_before_start_time">
                  3 Days Before Start Time
                </option>
                <option value="1week_before_start_time">
                  1 Week Before Start Time
                </option>
                <option value="2weeks_before_start_time">
                  2 Weeks Before Start Time
                </option>
                <option value="30days_before_start_time">
                  30 Days Before Start Time
                </option>
              </select>
            </div>
          </div>

          {/* <div className="grid grid-cols-3 gap-6 mb-8">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Scheduling suggestion order
              </label>
              <p className="text-xs text-gray-500 mb-2">
                Choose how suggested team members are displayed. Best fit
                spreads scheduled hours evenly amongst the team while minimising
                costs.
              </p>
            </div>
            <div>
              <select
                name="schedulingSuggestionOrder"
                // value={formData.firstDayOfWeek}
                onChange={handleChange}
                className="w-full rounded border-gray-300 bg-slate-100 p-2"
              >
                <option value="best_fit">Best Fit</option>
                <option value="alphabetically">Alphabetically(A-Z)</option>
                <option value="wage_cost">Wage Cost(Low To High)</option>
                <option value="hours_scheduled">
                  Hours Scheduled(Low To High)
                </option>
              </select>
            </div>
          </div>
          <SwitchRow
            label="Display location and area name when publishing shifts via SMS"
            description="The location and area names will be displayed instead of their codes. This may result in additional SMS charges."
            checked={formData.displayLocationAndAreas}
            onChange={(val) =>
              handleSwitchChange("displayLocationAndAreas", val)
            }
          /> */}
        </div>
      </div>

      {/* Swaps and offers */}
      <div className="bg-white p-6">
        <h2 className="text-2xl font-semibold text-gray-900 mb-6">
          Swaps and offers
        </h2>
        <div className="space-y-6">
          <div className="grid grid-cols-3 gap-6 mb-8">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Co-worker schedule visibility
              </label>
              <p className="text-xs text-gray-500 mb-2">
                If team members can view each other's schedule, you can enable
                shift swaps between team members.
              </p>
            </div>
            <div>
              <select
                name="coworkerScheduleVisibility"
                // value={formData.firstDayOfWeek}
                onChange={handleChange}
                className="w-full rounded border-gray-300 bg-slate-100 p-2"
              >
                <option value="allow_all">Allow All</option>
                <option value="allow_today">Only allow today's schedule</option>
                <option value="allow_none">
                  Allow none. Completely block all visibility
                </option>
              </select>
            </div>
          </div>
          <SwitchRow
            label="Swap shifts"
            description="Team members can swap shifts with each other if they both have the appropriate access."
            checked={formData.swapShifts}
            onChange={(val) => handleSwitchChange("swapShifts", val)}
          />

          <SwitchRow
            label="Manager approval for shift swaps"
            description="Option for managers to approve shift swaps."
            checked={formData.managerApprovalForShiftSwaps}
            onChange={(val) =>
              handleSwitchChange("managerApprovalForShiftSwaps", val)
            }
          />

          <SwitchRow
            label="Offer shifts"
            description="Team members can offer their shift to co-workers that are qualified and available. Manager approval is not required but will be notified when the shift has been accepted."
            checked={formData.offerShifts}
            onChange={(val) => handleSwitchChange("offerShifts", val)}
          />
        </div>
      </div>

      {/* Reporting */}
      {/* <div className="bg-white p-6">
        <h2 className="text-2xl font-semibold text-gray-900 mb-6">Reporting</h2>
        <div className="space-y-6">
          <div className="grid grid-cols-3 gap-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Overtime premium cost (%)
              </label>
              <p className="text-xs text-gray-500 mb-2">
                Add additional cost for all salaries and wages. This will show
                up on the Schedule screen and on the Schedule vs Timesheet or
                Sales report.
              </p>
            </div>
            <div>
              <input
                type="number"
                name="overtimePremiumCost"
                value={formData.overtimePremiumCost}
                onChange={handleChange}
                className="w-full rounded border-gray-300 bg-slate-100 p-2"
              />
            </div>
          </div>

          <div className="grid grid-cols-3 gap-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Default overtime/penalty shift cost (per hour)
              </label>
              <p className="text-xs text-gray-500 mb-2">
                Overtime/penalty shifts are included in overtime reports and
                overtime cost calculations on schedule and sales Business
                settings.
              </p>
            </div>
            <div>
              <input
                type="number"
                name="defaultOvertimeShiftCost"
                value={formData.defaultOvertimeShiftCost}
                onChange={handleChange}
                className="w-full rounded border-gray-300 bg-slate-100 p-2"
              />
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default EditScheduling;
